import React, { Fragment, useContext, useState } from "react";
import styled from "styled-components";
import { NativeViewOpen } from "../../common/NativeViewOpen/NativeViewOpen";
import { AppContext } from "../../../components/AppProvider";
import Recent from "./PrivateTerms/recent";

export default (props) => {
  const [timeSet, setTimeSet] = useState("NOW");
  const { userinfo, mypagecfg, auth, cfg, phonecfg, dispatch } = useContext(AppContext);

  return (
    <div>
      <div style={{ display: "flex" }}>
        <span className="tit">2. 개인정보 처리방침</span>
        <select
          style={{ marginLeft: "8px" }}
          onChange={e => setTimeSet(e.target.value)}>
          <option value={"NOW"}>2024/06/28 ~</option>
          <option value={"HIST3"}>2023/11/17 ~ 2024/06/28</option>
          <option value={"HIST2"}>2023/04/25 ~ 2023/11/16</option>
          <option value={"HIST"}>2020/06/01 ~ 2023/04/25</option>
        </select>
      </div>

      {timeSet === "NOW" && (
        <div className="terms-txtarea">
          <div
            className="terms-area"
            style={{ resize: "none", overflow: "auto" }}>
            {/* <ContentsPrivate /> */}
            <Recent />
          </div>
        </div>
      )}

      <Sector style={{ marginTop: "60px" }}>
        <SubTitle>개정이력</SubTitle>
        <div
          style={{ textDecoration: "underline" }}
          onClick={() =>
            NativeViewOpen(
              phonecfg.phoneOS,
              "https://pado.mdpeople.co.kr/#/mp/termsWebView/priv3"
              // "http://dev.mdpeople.co.kr/#/mp/termsWebView/priv3"
            )
          }>
          2024년06월28일
        </div>
        <div
          style={{ textDecoration: "underline" }}
          onClick={() =>
            NativeViewOpen(
              phonecfg.phoneOS,
              "https://pado.mdpeople.co.kr/#/mp/termsWebView/priv2"
            )
          }>
          2023년11월16일
        </div>
        <div
          style={{ textDecoration: "underline" }}
          onClick={() =>
            NativeViewOpen(
              phonecfg.phoneOS,
              "https://pado.mdpeople.co.kr/#/mp/termsWebView/priv"
            )
          }>
          2023년04월25일
        </div>
      </Sector>
    </div>
  );
};

export const ContentsPrivate = () => {
  return (
    <div>
      <Sector>
        <SubTitle>제1조(개인정보 처리목적)</SubTitle>

        <div>
          ㈜미라벨 소프트는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는
          다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를
          받는 등 필요한 조치를 이행할 예정입니다.
        </div>
      </Sector>

      <Sector>
        <SubTitle>제2조(개인정보 수집항목과 수집 방법)</SubTitle>

        <div>
          회사는 회원관리, 서비스 제공∙개선, 신규 서비스 개발 등을 위해 개인정보를 수집 및
          이용합니다. 또한 회사는 회원 가입시 또는 서비스 이용과정에서 홈페이지 또는 앱 서비스나
          프로그램 등을 통해 아래와 같이 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하고
          있습니다.
          <SubContents>가. [케어포미 서비스이용을 위한 수집항목]</SubContents>
          <SubContents>
            -필수정보:
            <SubContents>
              ● 이름, 성별, 생년월일, 휴대폰번호, 이메일, 로그인ID, 비밀번호, 중복가입확인정보(DI)
            </SubContents>
            <SubContents>● 개인데이터 공유 의료기관</SubContents>
            <SubContents>● 진료, 검사내역 및 재증명 발급내역</SubContents>
          </SubContents>
          <SubContents>
            -자동수집정보:
            <SubContents>● 접속로그, 쿠키</SubContents>
          </SubContents>
          <SubContents>
            나. [정보 수집방법]
            <SubContents>● 케어포미 앱 회원가입</SubContents>
            <SubContents>● 온·오프라인으로 진행하는 행사 및 이벤트 참여</SubContents>
          </SubContents>
        </div>
      </Sector>

      <Sector>
        <SubTitle>제3조(개인정보 이용목적)</SubTitle>
        <div>
          회사는 다음의 목적으로 개인정보를 수집합니다.
          <div style={{ display: "flex", textAlign: "center" }}>
            {/* 수집항목 */}
            <table style={{ width: "100%", textAlign: "center" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      width: "50%",
                      border: "1px solid #000",
                      borderLeft: "0px",
                      background: "#d0d0d0",
                      fontWeight: "600",
                    }}
                  >
                    수집항목
                  </td>
                  <td
                    style={{
                      width: "50%",
                      border: "1px solid #000",
                      borderRight: "0px",
                      background: "#d0d0d0",
                      fontWeight: "600",
                    }}
                  >
                    이용목적
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50%", border: "1px solid #000", borderLeft: "0px" }}>
                    이름, 성별, 생년월일, 휴대폰번호, 이메일, 로그인ID, 비밀번호,
                    중복가입확인정보(DI)
                  </td>
                  <td style={{ width: "50%", border: "1px solid #000", borderRight: "0px" }}>
                    회원관리(서비스 이용에 따른 본인확인 절차 등)
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50%", border: "1px solid #000", borderLeft: "0px" }}>
                    개인데이터 공유 의료기관
                  </td>
                  <td style={{ width: "50%", border: "1px solid #000", borderRight: "0px" }}>
                    진료자료, 검사자료, 예약현황 등에 대한 서비스 제공
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50%", border: "1px solid #000", borderLeft: "0px" }}>
                    이름, 휴대폰번호, 불편사항
                  </td>
                  <td style={{ width: "50%", border: "1px solid #000", borderRight: "0px" }}>
                    시스템 개선
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50%", border: "1px solid #000", borderLeft: "0px" }}>
                    접속로그, 쿠키
                  </td>
                  <td style={{ width: "50%", border: "1px solid #000", borderRight: "0px" }}>
                    시스템 및 이용자 관리
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Sector>

      <Sector>
        <SubTitle>제4조(개인정보의 처리 및 보유기간)</SubTitle>

        <div>
          1. 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에
          동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
        </div>
        <div>
          2. 각각의 개인정보 처리 및 보유기간은 다름과 같습니다.
          <SubContents>가. 관련법령 및 회사 방침에 의한 정보보유 사유</SubContents>
          <SubContents>-보존항목: 부정이용기록</SubContents>
          <SubContents>
            -보존이유: 부정이용방지(보존기간: 1년)
            <SubContents>
              (1) 계약 또는 청약철회 등에 관한 기록 : 5년(전자상거래등에서의 소비자보호에 관한 법률)
            </SubContents>
            <SubContents>
              (2) 대금결제 및 재화 등의 공급에 관한 기록: 5년(전자상거래등에서의 소비자보호에 관한
              법률)
            </SubContents>
            <SubContents>
              (3) 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래등에서의 소비자 보호에 관한
              법률)
            </SubContents>
            <SubContents>
              (4) 본인확인에 관한 기록 보유: 회원탈퇴시까지(정보통신망 이용촉진 및 정보보호 등에
              관한 법률)
            </SubContents>
            <SubContents>(5) 방문에 관한 기록 보유 : 3개월(통신비밀보호법)</SubContents>
          </SubContents>
        </div>

        <div>
          3. 수집된 개인정보의 보유/이용기간은 서비스 이용계약체결(회원가입)시부터 서비스
          이용계약해지(회원탈퇴, 직권탈퇴 포함)까지를 의미합니다.
        </div>
        <div>
          4. 회사는 불량 이용자의 부정한 이용의 재발을 방지하기 위해 또는 이용약관 및 관계 법령
          위반으로 인해 다른 이용자가 피해를 입는 것을 방지하고 사법기관 수사의뢰시 증거자료로
          활용하기 위해 서비스 이용계약 해지일(회원탈퇴일)로부터 6개월간 해당 이용자의 개인정보를
          보유할 수 있습니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용합니다.
        </div>
        <div>
          5. 이용자가 1년간 서비스 거래기록이 없을 경우, 그 서비스 이용자의 개인정보는 ‘정보통신망
          이용촉진 및 정보보호 등에 관한 법률 제29조’에 근거하여 이용자에게 사전통지하고 개인정보를
          파기하거나 별도로 분리하여 저장 및 관리합니다. 고객의 요청이 있을 경우에는 위 기간을 달리
          정할 수 있습니다. 단, 통신비밀보호법, 전자상거래 등에서의 소비자보호에 관한 법률 등의
          관계법령의 규정에 의하여 보존할 필요가 있는 경우 관계법령에서 규정한 일정한 기간 이용자의
          개인정보를 보관합니다.
        </div>
        <div>
          6. 회사는 위 1년 기간 만료 30일 전까지 개인정보가 파기되거나 분리되어 저장∙관리되는 사실과
          기간 만료일 및 해당 개인정보의 항목을 전자우편, 문자, 서비스 공지사항 등의 방법으로
          고객에게 알립니다. 이를 위해 고객은 정확한 연락처 정보를 제공∙수정해야 합니다.
        </div>
      </Sector>

      <Sector>
        <SubTitle>제5조(개인정보의 파기절차 및 방법)</SubTitle>

        <div>
          회사는 개인정보수집 및 이용목적을 달성한 후에는 지체없이 해당 정보를 파기합니다. 회사의
          개인정보 파기 절차 및 방법은 다음과 같다.
        </div>

        <div>1. 파기절차</div>
        <SubContents>
          가. 회사는 개인정보의 파기에 관한 사항을 기록하고 관리하며, 파기는 개인정보 보호 책임자의
          책임하에 수행되며, 개인정보 보호 책임자는 파기결과를 확인합니다.
        </SubContents>
        <SubContents>
          나. 회사는 다른 법령에 따라 보존해야 하는 경우에는 예외적으로 이용자의 개인 정보를
          파기하지 않을 수 있습니다.
        </SubContents>

        <div>2. 파기방법</div>
        <SubContents>
          가. 종이나 그 밖의 기록매체에 저장된 개인 정보는 파쇄하거나 소각합니다.
        </SubContents>
        <SubContents>
          나. 전자적 파일의 형태로 저장된 개인정보는 복원이 불가능한 방법(내지 기록을 재생할 수 없는
          기술적 방법)으로 영구 삭제합니다.{" "}
        </SubContents>

        <div>
          미파기 정보의 보존 방법 회사는 법령에 따라 개인정보를 파기하지 않고 보존하는 경우 해당
          개인정보 또 는 개인정보파일을 다른 개인정보와 분리하여 저장.관리합니다. 회사는 별도 DB 로
          옮긴 개인정보를 법률에 의한 경우가 아니고서는 보유하는 목적 이외의 목적 으로 이용하지
          않습니다.
        </div>
      </Sector>

      <Sector>
        <SubTitle>제6조(개인정보 제3자 제공)</SubTitle>
        <div>
          1. 회사는 개인정보를 제3조(개인정보 이용목적)에서 명시한 범위 내에서만 처리합니다.
        </div>
        <table style={{ textAlign: "center", width: "100%", marginBottom: "4px" }}>
          <tbody>
            <tr>
              <td
                style={{
                  width: "30%",
                  border: "1px solid #000",
                  borderLeft: "0px",
                  background: "#d0d0d0",
                  fontWeight: "600",
                }}
              >
                개인정보를 제공받는 자
              </td>
              <td
                style={{
                  width: "40%",
                  border: "1px solid #000",
                  borderLeft: "0px",
                  background: "#d0d0d0",
                  fontWeight: "600",
                }}
              >
                이용목적
              </td>
              <td
                style={{
                  width: "30%",
                  border: "1px solid #000",
                  borderRight: "0px",
                  background: "#d0d0d0",
                  fontWeight: "600",
                }}
              >
                제공하는 개인정보 항목
              </td>
            </tr>
            <tr>
              <td style={{ width: "30%", border: "1px solid #000", borderLeft: "0px" }}>
                회원이 개인데이터 공유를 신청한 의료기관
              </td>
              <td style={{ width: "40%", border: "1px solid #000", borderLeft: "0px" }}>
                회원의 진료자료, 제증명서류, 병원예약(서비스 개발중), 검사스케줄 서비스 제공
              </td>
              <td style={{ width: "30%", border: "1px solid #000", borderRight: "0px" }}>
                이름, 생년월일, 성별, 휴대폰번호,환자ID
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          2. 회사는 이용자가 진료를 목적으로 개인정보제공을 동의한 경우에만 이용자가 지정한
          의료기관에 제공합니다.
        </div>
        <div>
          3. 만일 회사가 제3자에게 이용자의 개인정보를 제공할 경우에는 이용자가 거부할 권리가 있다는
          사실을 이용자에게 알리고 별도의 동의를 받습니다. 이와 같은 사실을 변경하는 경우에는 이를
          알리고 이용자의 동의를 받습니다.
        </div>
      </Sector>

      <Sector>
        <SubTitle>제7조(개인정보주체의 권리와 그 행사방법)</SubTitle>

        <div>
          1. 이용자는 언제든지 회사의 서비스에 등록되어있는 자신의 개인정보, 회사가 이 용자의
          개인정보를 이용하거나 제3자에게 제공한 현황, 회사에게 개인정보 수집.이용.제공 등의 동의를
          한 현황에 대하여 열람이나 제공을 요구할 수 있고, 오류 가 있는 경우에는 그 정정을 요구할 수
          있으며, 삭제 내지 가입해지(회원탈퇴)를 요구할 수 있습니다.
        </div>
        <div>
          2. 이용자 혹은 만14세 미만 아동의 개인정보 조회 및 그 수정을 위해서는 ‘개인정보변경’(또는
          ‘이용자 정보 수정’ 등)을, 가입해지(동의철회)를 위해서는 ‘이용자 탈퇴’(또는 ‘회원 탈퇴’
          등)를 클릭하여 직접 열람한 후 정정 또는 탈퇴가 가능합니다.
        </div>
        <div>
          3. 전 2항의 경우 회사는 지체없이 그 개인정보를 조사하여 이용자의 요구에 따라 정정, 삭제 등
          필요한 조치를 한 후 그 결과를 그 이용자에게 알립니다. 회사는 필요한 조치를 취할 때까지는
          해당 개인정보를 이용하거나 제공하지 않습니다.
        </div>
        <div>
          4. 이용자는 언제든지 회사에 자신의 개인정보 처리의 정지를 요구할 수 있으며, 이 경우 회사는
          지체없이 그 요구에 따라 개인정보 처리의 전부 또는 일부를 정지하며, 처리가 정지된
          개인정보에 대하여 지체없이 그 개인정보의 파기 등 필요한 조치를 취합니다.
        </div>
        <div>
          5. 개인정보와 관련하여 의견이 있으신 분은 개인정보 보호 책임자 및 담당자에게 서면, 전화
          또는 E-mail로 연락하시면, 접수 즉시 처리하고 그 결과를 안내해 드리겠습니다.
        </div>
        <div>
          6. 이용자는 로그온(log-on)한 상태에서는 주위의 다른 사람에게 개인정보가 유출되지 않도록
          특별히 주의를 하셔야 합니다.
        </div>
      </Sector>

      <Sector>
        <SubTitle>제8조(개인정보의 기술적, 관리적 보호 대책)</SubTitle>

        <div>
          회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지
          않도록 안전성의 확보를 위해 다음과 같은 기술적. 관리적 보호 대 책을 강구하고 있습니다.
        </div>

        <div>1. 기술적 조치</div>
        <SubContents>
          가. 비밀번호 암호화 회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있어 이용자만
          알고 있으며 회사가 이를 직접 조회하거나 수정할 수 없습니다. 또한 개인정보의 확인 및 변경도
          계정정보를 통해 일치하는 경우에만 가능합니다.
        </SubContents>

        <div>2. 관리적 보호 대책</div>
        <SubContents>
          가. 해킹 등에 대한 대비책 회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가
          유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 또한 개인정보의 훼손에 대비해서
          자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가
          유출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서
          개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여
          외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한
          모든 기술적 장치를 갖추려 최선을 다하고 있습니다.
        </SubContents>
      </Sector>

      <Sector>
        <SubTitle>제9조(개인정보 자동 수집장치의 설치·운영 및 거부에 관한 사항)</SubTitle>

        <div>1. 쿠키(cookie)의 사용</div>
        <SubContents>
          가. 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해 ‘쿠키(cookie)’를 사용합니다.
        </SubContents>
        <SubContents>
          나. 쿠키란 웹사이드를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 작은 텍스트
          파일로서 이용자의 하드디스크에 저장됩니다.{" "}
        </SubContents>

        <div>2. 쿠키(cookie)의 사용 목적</div>
        <SubContents>
          가. 회사는 이용자의 접속방법에 대한 유형을 파악하여 서비스 개선에 활용합니다.
        </SubContents>
        <SubContents>
          나. 회사는 쿠키를 통해 서비스의 접속, 방문시간 및 빈도 등을 분석하여 이용자에게 보다 빠른
          서비스 제공에 활용합니다.
        </SubContents>

        <div>3. 쿠키(cookie)의 설정 거부</div>
        <SubContents>
          가. 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서
          옵션을 설정하여 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든
          쿠키의 저장을 거부할 수도 있습니다.
        </SubContents>
        <SubContents>
          나. 쿠키 설치 허용 여부를 지정하는 방법은 다음과 같습니다. (인터넷 익스플로러의 경우): 웹
          브러우저 상단의 도구{">"} 인터넷 옵션{">"} 개인정보 탭{">"}개인정보처리 수준(구글 크롬의
          경우): 웹 브라우저 상단의 설정{">"} 개인정보 및 보안{">"} 쿠키 및 기타
          사이트(마이크로소프트 엣지의 경우): 웹 브러우저 상단의 설정 {">"} 쿠키 및 사이트 권한단,
          쿠키 저장을 거부하셨을 경우 로그인 및 필요한 서비스 사용에 어려움이 있을 수 있습니다.
        </SubContents>
      </Sector>

      <Sector>
        <SubTitle>제10조(개인정보보호 책임자 및 담당자의 연락처)</SubTitle>

        <div>
          1. 회사는 이용자의 개인정보를 보호하고 개인정보를 안전하게 보호하기 위해 아래와 같은
          담당자를 지정하고 있습니다. 또한 이용자의 신고사항에 신속하게 답변을 드리기 위해 노력하고
          있습니다.
        </div>
        <SubContents>가. 개인정보보호 책임자: 류대선</SubContents>
        <SubContents>나. 소속/ 직위: 미라벨소프트/ 이사</SubContents>
        <SubContents>다. 전화번호: 1877-4872</SubContents>
        <SubContents>라. 이메일: dsryu@mirabellsoft.com</SubContents>

        <div>
          2. 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기
          바랍니다.{" "}
        </div>
        <SubContents>
          가. 개인정보침해 신고센터 (http://privacy.kisa.or.kr / 국번 없이 118)
        </SubContents>
        <SubContents>나. 대검찰청 사이버수사과 (www.spo.go.kr / 국번 없이 1301)</SubContents>
        <SubContents>다. 경찰청 사이버수사국(https://ecrm.cyber.go.kr)</SubContents>
        <SubContents>라. 개인정보 분쟁조정위원회(www.kopico.go.kr / 1833-6972)</SubContents>
      </Sector>

      <Sector>
        <SubTitle>제11조(개정 전 고지 의무)</SubTitle>

        <div>
          1. 현 개인정보 처리방침은에 대해 추가, 삭제 및 수정이 있을시에는 개정 최초 7일 전부터
          서비스 ‘공지사항’을 통해 고지할 것입니다.{" "}
        </div>
        <div>
          2. 전항에도 불구하고 이용자 권리에 대한 중대한 내용이 변경되는 경우 최소 30일 전에 고지
          합니다. 변경된 개인정보 처리방침은 고지한 적용일로부터 효력이 발생합니다.{" "}
        </div>
      </Sector>

      <Sector>
        <div style={{ textAlign: "left", width: "100%" }}>공고일자: 2023년 4월 25일</div>
        <div style={{ textAlign: "left", width: "100%" }}>시행일자: 2023년 4월 25일</div>
      </Sector>
    </div>
  );
};

const Sector = styled.div`
  margin-bottom: 8px;
`;

const SubTitle = styled.div`
  font-weight: 700;
`;

const SubContents = styled.p`
  margin-left: 8px;
`;

export const ContentsPrivateHist = (props) => {
  return (
    <div>
      <div className="terms-txtarea">
        <div
          className="terms-area"
          style={{ resize: "none", overflow: "auto" }}>
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {`개인정보처리방침
가. "개인정보"라 함은 생존하고 있는 개인에 관한 정보로서 성명, 주민등록번호 및 영상 등을 통하여 개인을 알아볼 수 있는 정보(해당 정보만으로는 특정 개인을 알아볼 수 없더라도 다른 정보와 쉽게 결합하여 알아볼 수 있는 것을 포함한다)를 말합니다.
나. “케어포미” 서비스(이하 “서비스”라 함)는 고객님의 개인정보보호를 매우 중요시하며, 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보 보호법』상의 개인정보보호규정을 준수하고 있습니다. 또한 “서비스”는 개인정보 처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떤 용도와 방식으로 이용되고 있으며 개인정보를 효과적이고 적극적으로 보호하기 위해 항상 노력하고 있음에 대해 알려드립니다.
다. ”서비스”는 개인정보 처리방침을 본 서비스 애플리케이션(이하 ‘케어포미 App.’이라 합니다)App 설정 메뉴의 버전 정보 화면에 공개함으로써 고객님께서 언제나 용이하게 보실 수 있도록 조치하고 있습니다.
라. ”서비스”는 개인정보 처리방침의 지속적인 개선을 위하여 개인정보 처리방침을 개정하는데 필요한 절차를 정하고 있습니다. 그리고 개인정보 처리방침을 개정하는 경우 버전번호, 시행일자 등을 부여하여 개정된 내용을 확인할 수 있도록 하고 있습니다.
마. ”서비스”의 개인정보 처리방침 중 중요한 사항이 변경되는 경우에는 변경되는 개인정보 처리방침을 시행하기 7일전부터 케어포미 App 등을 통하여 변경이유 및 내용을 고객에게 공지합니다.
	개인정보의 수집 항목 및 이용 목적
가. "회사"는 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 아래와 같은 최소한의 개인정보를 필수항목으로 수집하고 있습니다.
나. ”서비스”는 고객의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다. 다만, “서비스” 제공을 위한 건강에 관한 정보는 고객님의 별도 동의 하에 수집할 수 있습니다. 
다. 개인정보 수집항목 및 이용목적 리스트
회원식별 및 가입의사 확인, 회원관리
민원처리 및 고객 상담
서비스 이용 과정 중 본인식별, 인증, 실명확인 및 각종 안내/고지
불법, 부정이용 방지 및 비인가 사용방침
결제서비스(거래승인)
서비스 방문 및 이용기록 및 통계
다양한 서비스 및 신규 서비스 제공
알림 서비스
이용자(이하 "회원"이라 함) 개인정보의 수집·이용 목적과 개인정보 항목은 아래와 같습니다.
구분	수집방법	이용목적	수집항목	수집이용기간
회원가입	공통	회원가입 시	회원 가입 및 회원관리	필수)이메일, 이름, 휴대폰번호, 이용로그
선택)주소	서비스 회원 탈퇴 및 이용계약 종료 시
(단,관련법령에 따라 별도 보관되는 정보는 예외)
일반회원	이메일, 이름, 휴대폰번호, 이용로그
카카오 계정으로 가입	필수)카카오 연동ID, 카카오 토큰, 프로필사진
페이스북 계정으로 가입	필수)페이스북 연동ID, 페이스북 토큰, 성명, 프로필사진
네이버 계정으로 가입	필수)네이버 연동ID, 네이버 토큰
애플 계정으로 가입          필수)애플 연동ID, 애플 토큰, 성명, 프로필사진
선택)성별, 생일, 연령대
접수/예약 서비스	본인 또는 가족	접수/예약 신청시	접수/예약서비스 이용	이름, 생년월일, 성별, 휴대폰번호, 주소, 사전문진 정보, 내외국인 여부
전화예약진료	본인 또는 가족	전화상담진료 신청시	전화상담진료 서비스 이용	이름, 생년월일, 성별, 휴대폰번호, 주소, 사전문진 정보, 내외국인 여부, 진료비, 처방전
결제서비스	카드 등록 및 결제서비스 이용시	결제대행서비스 이용	본인 결제정보 카드번호, 유효기간(년./월), 카드비밀번호 앞 2자리, CVC, 서명, 결제내역, 처방정보
이벤트 응모 및 기타 문의사항(선택)	이벤트 응모 및 기타 문의사항 신청시	이벤트 응모 및 당첨자 선정, 당첨 안내 및 경품 지급, 서비스 문의 안내	이름, 전화번호, 이메일, 주소
기타서비스	기타 서비스 이용을 위해 회원이 직접 입력시	기타 서비스 이용 건강피드, 처방전 복약관리 등 기타 서비스 이용시 회원이 직접 입력하는 항목
"회사"는 귀하의 개인정보보호를 매우 중요시하며, 『개인정보 보호법』과 『정보통신망 이용촉진 및 정보보호 등에 관한법률』상의 개인정보 처리방침 및 행정안전부와 정보통신부가 제정한 『개인정보 보호지침』을 준수하고 있습니다. 회사는 개인정보처리방침을 통하여 귀하께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
"회사"는 개인정보 처리방침을 사이트 첫 화면과 고객센터의 '개인정보 처리방침' 항목에서 공개함으로써 회원들이 언제나 용이하게 보실 수 있도록 조치하고 있습니다.
"회사"는 개인정보 처리방침의 지속적인 개선을 위하여 개인정보 처리방침을 개정하는데 필요한 절차를 정하고 있습니다. 그리고 개인정보 처리방침을 개정하는 경우 버전번호 등을 부여하여 개정된 사항을 귀하께서 쉽게 알아볼 수 있도록 하고 있습니다.
"회사"는 귀하의 결제 서비스 이용을 처리하기 위하여 회원의 해당 결제수단 발행자에게(예: 등록한 카드의 카드사) 결제정보, 개인정보 등이 전송되며, 회사는 본 업무처리를 위하여 개인의 카드정보와 관련된 항목을 별도 보관하지 않습니다.
부가 서비스 및 맞춤식 서비스 이용 또는 이벤트 응모 과정에서 위와 같은 정보들이 수집될 수 있습니다.
기타 "회사"가 제공하는 정보 전달, 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공에 활용되고 있습니다.
1) 개인정보(일반회원)
• 수집항목
-	아이디, 비밀번호, 닉네임, 휴대폰 번호, 이메일 주소, 생년월일, 체중, 키, 성별, 프로
-	걷기, 체중 기록(활동량 측정 앱 및 기기를 연결하여 수집), 식사∙운동∙혈당∙혈압 기록, 운동습관, 흡연력, 음주력, 체력측정결과, 운동자세 동영상, 통계 데이터, 서비스를 위해 필요한 문진내용 전체, 인바디 측정결과, 체중, 협력 병원과 연관된 환자 개인 진료 정보, 사진, 가입∙해지일, 접속기록, 서비스 이용현황
• 이용목적
-	본인 식별, 가입 의사 확인, 케어포미 건강관리 서비스 제공(가입, 변경, 해지 포함), 불량 회원의 부정한 이용 방지, 고객상담, 민원사항 처리, 분쟁 조정을 위한 기록 보존, 고지 사항 전달, 회원 참여 공간 운영, 설문(문진) 조사
-	건강관리 서비스 제공, 이용자의 건강분석∙관리, 고객 상담, 서비스 효과 분석
	개인정보 수집에 대한 동의
가. “서비스”는 ‘케어포미 App.’내에서 고객님의 ‘개인정보 수집 및 이용’에 대한 별도의 동의획득 절차를 두고, 고객님께서 이에 대해 '동의' 버튼을 클릭할 수 있는 절차를 마련하고 있습니다. '동의' 버튼을 클릭하면 개인정보 수집 및 이용에 대해 동의한 것으로 봅니다.
나. 고객님은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우 받는 별도의 불이익은 없습니다. 단, 필수동의 사항에 동의를 거부할 경우, 서비스 이용이 불가능하거나, 서비스 이용 목적에 따른 서비스 제공에 제한이 따르게 됩니다.
	개인정보의 수집 방법
가. 본 서비스는 케어포미 App. 회원가입 절차, 상담 절차, 이벤트나 경품 행사를 통한 수집, 업무위탁사 또는 제휴사 등으로부터의 수집, 이동 전화 및 유-무선 인터넷 서비스 사용시 생성정보 수집 툴을 통한 방법(쿠키) 등으로 개인 정보를 수집합니다. 또한 기업형 서비스의 경우 고객이 소속한 회사로부터 서비스 이용에 관련 있는 개인정보(사번, 소속부서, 근무위치, 체성분분석기, 체력측정장비, 시설이용현황 등)를 제공받을 수 있습니다.
	수집한 개인정보의 이용 및 제3자 제공
가. “서비스”는 고객님의 개인정보를 서비스이용약관, 본 개인정보 처리방침의 '개인정보의 수집 항목 및 이용 목적'에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업 · 기관에 제공하지 않습니다. 단, 다음의 경우에는 주의를 기울여 개인정보를 이용 및 제공할 수 있습니다.
-	제휴관계 
보다 나은 “서비스” 제공을 위하여 고객의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다. 개인정보를 제공하거나 공유할 경우에는 사전에 고객께 제휴사가 누구인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지, 그리고 언제까지 어떻게 보호 · 관리되는지에 대해 개별적으로 서면 또는 전자우편 등을 통해 고지하여 동의를 구하는 절차를 거치게 되며, 고객께서 동의하지 않는 경우에는 제휴사에게 제공하거나 제휴사와 공유하지 않습니다. 제휴관계에 변화가 있거나 제휴관계가 종결될 때도 같은 절차에 의하여 고지하거나 동의를 구합니다.
	개인정보 처리업무의 위탁
가. “서비스”는 업무위탁계약서 등을 통하여 개인정보보호 관련 법규의 준수, 개인정보에 관한 비밀유지, 제3자 제공에 대한 금지, 사고시의 책임부담, 위탁기간, 처리 종료 후의 개인정보의 반환 또는 파기 의무 등을 규정하고, 이를 준수하도록 관리하고 있습니다.
나. 위탁 업무 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있으며 변경 시 공지사항을 통해 사전 공지합니다.
위탁업무: 건강관리 서비스 운영 및 이용내역 관리, 건강/식이/운동 상담, 개인별 운동처방, 체력평가, 건강컨텐츠 제공 및 커뮤니티 운영
	개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
회사는 회원들에게 특화된 맞춤서비스를 제공하기 위해서 회원들의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버(HTTP)가 회원의 컴퓨터 브라우저에게 보내는 소량의 정보이며 회원들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
-	쿠키 및 푸쉬의 사용 목적 : 회원들이 방문한 "케어포미"의 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 회원 규모 등을 파악하여 회원에게 최적화된 정보 제공을 위하여 사용합니다.
-	또한, 회원의 입력한 자가건강관리 정보와 협력병원에서 공유되는 진료기록 정보에 대해서 서비스이용약관과 개인정보처리방침에 동의를 한 후 협력 병원에 공유가 가능하며 의료법의 기준에 따라 이에 대한 책임은 협력 병원에 있습니다. 단, 회원이 “케어포미.APP”에서 임의적인 설정으로 추후 거부가 가능합니다. . 
	개인정보의 열람, 정정, 동의 철회(회원탈퇴)
가. 고객님은 언제든지 등록되어 있는 고객님의 개인정보를 열람하거나 정정하실 수 있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 '회원정보변경’을 클릭하여 직접 열람 또는 정정하실 수 있습니다.
나. “서비스”는 고객이 개인정보에 대한 열람 · 증명 또는 정정을 요구하는 경우에는 고객의 요구에 성실하게 대응하고, 해당 개인정보에 오류가 있거나 보존기간을 경과한 것이 판명되는 등 정정ㆍ삭제를 할 필요가 있다고 인정되는 경우에는 지체 없이 정정 · 삭제를 합니다.
다. 또한 회원가입 등을 통해 개인정보의 수집, 이용, 제공에 대해 동의하신 내용을 언제든지 철회하실 수 있습니다. 동의 철회(회원탈퇴)를 하고자 할 경우에는 '회원탈퇴'를 클릭하여 직접 신청하실 수 있습니다. 
	개인정보의 보유기간 및 이용기간
가. 회사는 고객님의 “서비스” 가입일로부터 고객님께 “서비스”를 제공하는 기간 동안에 한하여 고객님의 개인정보를 보유 및 이용하게 됩니다. 회원 탈퇴를 요청하거나 개인정보의 수집 및 이용에 대한 동의를 철회하는 경우, 수집·이용목적을 달성하거나 보유·이용기간이 종료한 경우, 사업폐지 등의 사유발생시 당해 개인정보를 지체없이 파기합니다. 단, 부당재가입 방지, 요금정산 및 과오납 등에 대한 처리를 위해 본문에 따른 회원 탈퇴일 등으로부터 6개월간 보유합니다. 단, 협력 병원에 공유된 회원의 자가건강관리 정보와 개인진료정보는 의료법에 입각한 기간 동안 협력병원에서 보관하며 추후에 이에 대한 관리책임이 협력 병원에 있습니다.   
나. 또한 상법, 국세기본법, 통신비밀보호법, 전자상거래 등에서 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률 등 관계법령에 따라 보존할 필요가 있는 경우 회사는 관계법령에서 정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 다음과 같습니다.
1) 상업장부와 영업에 관한 중요서류 및 전표 : 중요서류는 10년 / 전표(상법)는 5년
2) 거래에 관한 장부 및 증빙서류 : 5년(국세기본법, 법인세법, 부가가치세법 등)
3) 통신사실확인자료 제공시 필요한 가입자의 전기통신 일시, 전기통신 개시∙종료시간, 통신번호 등 상대방의 가입자번호, 사용초, 통신신망에 접속된 정보통신기기의 위치추적자료 : 12개월(통신비밀보호법)
4) 통신사실확인자료 제공시 필요한 로그기록자료, IP주소 등 : 3개월(통신비밀보호법)
5) 표시/광고에 관한 기록 : 6개월(전자상거래등에서의 소비자보호에 관한 법률)
6) 계약 또는 청약철회 등에 관한 기록 : 5년(전자상거래등에서의 소비자보호에 관한 법률)
7) 대금결제 및 재화 등의 공급에 관한 기록 : 5년(전자상거래등에서의 소비자보호에 관한 법률)
8) 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년(전자상거래등에서의 소비자보호에 관한 법률)
9) 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년(신용정보의 이용 및 보호에 관한 법률)
	개인정보 파기 절차 및 방법
가. “서비스”는 수집한 개인정보의 이용목적이 달성된 후에는 보관기간 및 이용기간에 따라 해당 정보를 지체 없이 복구불가능하도록 파기합니다. 파기절차, 방법, 시점은 다음과 같습니다.
1) 파기절차 및 시점
고객이 “서비스” 가입 등을 위해 기재한 개인정보는 “서비스” 해지 등 이용목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 방침에 의해 삭제되거나 파기합니다. 일반적으로 채권-채무 관계가 없는 경우, “서비스” 가입시시 수집되어 전자적 파일형태로 관리하는 개인정보는 회원 탈퇴 시점에 바로 삭제 됩니다. 단, 고객에게 미리 고지하고 개별 동의를 받은 경우는 동의한 내용에 따른 보유기간 동안 보유 후 삭제되며, 관련 법령의 규정에 의하여 개인정보를 보유해야 할 필요가 있는 경우에는 해당 법령에서 정한 기간 동안 보유한 후 해당 기간이 지나면 회원의 모든 데이터를 삭제합니다. 또한, 회원의 서비스 이용약관과 개인정보처리방침 동의한 후, 협력 병원에 공유된 자가건강관리 정보와 개인진료기록의 경우 의료법에 입각한 기간 동안 협력병원에서 보관하며 이에 대한 책임이 협력 병원에 있음을 고지합니다.  
2) 파기방법
가입신청서 등 서면양식에 기재하거나, 종이에 출력된 개인정보는 분쇄기로 분쇄 또는 소각하거나 화학약품 처리를 하여 용해하여 파기하고, 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
	만 14세 미만 아동의 법정대리인의 권리와 그 행사 방법
가. 회사는 만 14세 미만의 아동으로부터 개인정보 수집·이용·제공하는 경우, 관련 법령에 따라 그 법정대리인의 동의를 받습니다. 이 경우 회사는 그 아동에게 법정대리인의 동의를 받기 위하여 필요한 법정대리인의 성명 등 최소한의 정보를 요구할 수 있습니다.
나. 만 14세 미만 아동의 법정대리인은 아동의 개인정보에 대한 열람, 수정 및 삭제를 요청할 수 있으며, 회사는 이러한 요청에 지체 없이 필요한 조치를 취합니다.
	이용자의 권리와 의무
가. 고객님의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를 예방해 주시기 바랍니다. 입력한 부정확한 정보로 인해 발생하는 사고의 책임은 고객님께 있으며 타인 정보의 도용 등 허위정보를 입력할 경우 회원자격이 상실될 수 있습니다.
나. 고객님은 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도 가지고 있습니다. 패스워드를 포함한 고객님의 개인정보가 유출되지 않도록 조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오. 만약 이 같은 책임을 다하지 못하고 타인의 정보를 훼손할 시에는 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』등에 의해 처벌받을 수 있습니다.
	개인정보 자동 수집 장치의 설치/운영 및 그 거부에 대한 사항
가. “서비스”에서 제공하는 인터넷서비스를 통하여 고객님의 정보를 저장하고 수시로 찾아내는 쿠키(cookie)를 설치/운용할 경우도 있습니다. 쿠키란 웹 서버가 웹 브라우저에 보내어 저장했다가 서버의 부가적인 요청이 있을 때 다시 서버로 보내주는 문자열 정보를 말합니다. 고객님께서 “서비스” 웹사이트에 접속을 하면 고객님의 브라우저에 있는 쿠키의 내용을 읽고, 추가정보를 찾아 접속에 따른 성명 등의 추가 입력 없이 서비스를 제공할 수 있습니다.
나. “서비스”가 쿠키를 통해 수집하는 정보는 회원의 ID에 한하며, 그 외의 다른 정보는 수집하지 않습니다. 회사가 쿠키(cookie)를 통해 수집한 회원의 ID는 다음의 목적을 위해 사용될 수 있습니다.
1) 개인의 관심 분야에 따라 차별화된 정보를 제공
2) 회원과 비회원의 접속 빈도 또는 머문 시간 등을 분석하여 이용자의 취향과 관심분야를 파악하여 마케팅에 활용
3) 관심 있게 둘러본 내용들에 대한 자취를 추적하여 다음 번 접속 때 개인 맞춤 서비스를 제공
4) 유료서비스 이용 시 이용기간 안내
5) 회원들의 습관을 분석하여 서비스 개편 등의 척도로 활용
다. 고객님께서는 쿠키 설치에 대한 선택권을 가지고 있습니다. 웹 브라우저 상단의 “도구 > 인터넷옵션 > 개인정보 > 고급”에서 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있습니다. 단, 고객님께서 쿠키 설치를 거부하였을 경우 서비스 이용에 불편이 있거나, 서비스 제공에 어려움이 있을 수 있습니다. 쿠키는 브라우저의 종료 시나 로그 아웃 시 만료됩니다.
	개인정보 처리방침의 고지 또는 통지방법
가. ”서비스”가 개인정보 수집시 고지한 범위 또는 서비스이용약관, 본 개인정보 처리방침에 명시한 범위를 넘어 고객의 개인정보를 이용하거나 제3자에게 제공하기 위해 고객의 동의를 얻고자 하는 때에는 미리 고객에게 개별적으로 서면, 전자우편, 전화 등으로 해당사항을 고지합니다. 타인에게 고객의 개인정보의 수집·보관·처리·이용·제공·관리·파기 등을 위탁하는 경우에는 가입신청서, 서비스이용약관, 웹사이트의 개인정보 처리방침 등을 통하여 그 사실을 고객에게 고지합니다.
나. ”서비스”가 영업의 전부 또는 일부를 양도하거나 합병ㆍ상속 등으로 그 권리ㆍ의무를 이전하는 경우 서면ㆍ전자우편 등을 통하여 고객에게 개별적으로 통지함과 동시에 케어포미 App. 첫 화면에서 식별할 수 있도록 표기하여 30일 이상 그 사실을 공지합니다. 다만, 서면ㆍ전자우편에 의한 통지는 과실 없이 고객의 연락처를 알지 못하거나 천재ㆍ지변 기타 통지할 수 없는 정당한 이유가 있는 경우에는 케어포미 App. 첫 화면에서 공지하는 것으로 갈음합니다.
다. 만 14세 미만 아동의 개인정보 수집ㆍ이용 또는 제3자에게 제공하기 위하여 법정대리인의 동의를 받고자 하는 경우에는 전화, 팩스, 우편, 아동으로 하여금 통지내용을 법정대리인에게 제출하게 하는 방법, 법정대리인에게 전자우편을 보내면서 개인정보 처리방침을 볼 수 있도록 연결(하이퍼링크)시키는 방법 또는 기타 법정대리인에게 고지내용이 도달할 수 있는 합리적인 방법(휴대폰 인증 등)을 통하여 법정대리인에게 고지합니다.
	개인정보보호를 위한 기술 및 관리적 대책
가. “서비스”에서는 고객님의 개인정보를 보호하기 위해 기술적 대책과 관리적 대책을 마련하고 있으며, 이를 적용하고 있습니다.
1) 기술적 대책
• “서비스”는 고객님의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
- 고객님의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.
- ”서비스”는 백신프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
- ”서비스”는 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.
- 해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및 취약점 분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.
2) 관리적 대책 
• “서비스”는 개인정보의 안전한 보호를 위하여 주요 시스템 및 설비에 대하여 외부 전문기관으로부터 정보보호관리체계 인증 등 객관적인 인증을 받아 운영되고 있습니다.
• “서비스”는 고객의 개인정보에 대한 접근 및 관리에 필요한 절차 등을 마련하여 소속 직원으로 하여금 이를 숙지하고 준수하도록 하고 있습니다.
• “서비스”는 고객님의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.
-이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자
-개인정보보호책임자 및 담당자 등 개인정보관리업무를 수행하는 자
-기타 업무상 개인정보의 처리가 불가피한 자
• ”서비스”는 컴퓨터를 이용하여 고객의 개인정보를 처리하는 경우 개인정보에 대한 접근권한을 가진 담당자를 지정하여 식별부호(ID) 및 비밀번호를 부여하고, 해당 비밀번호를 정기적으로 갱신하고 있습니다.
• 개인정보를 처리하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육 및 외부 위탁교육을 실시하고 있습니다.
• 신규직원 채용 시 정보보호서약서 또는 개인정보보호서약서에 서명함으로 직원에 의한 정보유출을 사전에 방지하고 개인정보 처리방침에 대한 이행사항 및 직원의 준수여부를 감사하기 위한 내부절차를 마련하여 지속적으로 시행하고 있습니다.
• 직원 퇴직 시 비밀유지서약서에 서명함으로 고객의 개인정보를 처리하였던 자가 직무상 알게 된 개인정보를 훼손ㆍ침해 또는 누설하지 않도록 하고 있습니다.
• 개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확히 하고 있습니다.
• 전산실 및 자료 보관실 등을 특별 보호구역으로 설정하여 출입을 통제하고 있습니다.
• 서비스이용계약체결 또는 서비스제공을 위하여 고객의 신용카드번호, 은행결제계좌 등 대금결재에 관한 정보를 수집하거나 고객에게 제공하는 경우 당해 고객이 본인임을 확인하기 위하여 필요한 조치를 취하고 있습니다.
• 회사는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 회원 개개인이 본인의 개인정보를 보호하기 위해서 자신의 ID 와 패스워드를 적절하게 관리하고 여기에 대한 책임을 져야 합니다.
• 또한, 다른 사람이 추측할 수 있는 쉬운 비밀번호는 사용을 피하시기를 권장하며, 정기적으로 비밀번호를 변경하시는 것이 바람직합니다.
• 특히, 공동으로 사용하는 PC에서 저희 홈페이지를 접속하여 로그인한 상태에서 다른 사이트로 이동하는 경우, “서비스”이용을 종료하는 경우에는 반드시 로그아웃 처리 후 해당 홈페이지를 종료하시기 바랍니다. 그렇지 않을 경우, 해당 브라우저를 통해 ID, 비밀번호 등 고객님의 정보가 타인에게 쉽게 유출될 위험이 있습니다.
• 그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 변조, 훼손이 유발될 경우 “서비스”는 즉각 고객님께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다.
	의견 수렴 및 불만 처리
가. 회사는 고객의 의견을 매우 소중하게 생각합니다. 고객께서 문의사항이 있을 경우 고객센터 등에 연락을 하여 문의하시면 신속 · 정확한 답변을 드리겠습니다. 문의처는 다음과 같습니다.
1) 사이버상담 : 본 서비스에 접속하신 후 고객센터 메뉴의 1:1 문의 코너에서 사이버 상담원에게 질문을 하실 수 있습니다.
2) E-mail : dsryu@mirabellsoft.com
	개인정보보호 책임자 및 담당자
가. 회사는 고객님이 안전하게 서비스를 이용할 수 있도록 개인정보 보호에 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 고객님께 고지한 사항들에 반하는 사고가 발생할 시에 개인정보보호책임자가 모든 책임을 집니다. 고객님의 개인정보를 처리하는 책임자 및 담당자는 다음과 같으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해드리고 있습니다.
나. 개인정보 보호책임자 및 담당자
1) 성명: 류대선
2) 직위(직책): 이사
3) 이메일: dsryu@mirabellsoft.com
4). 연락처: 1877-4872
	아동의 개인정보보호
가. 회사는 “서비스” 이용과 관련하여 만 14세 미만 아동(이하 “아동”이라 함)의 개인정보를 수집/이용/제공하는 경우, 해당 아동의 개인정보로 인하여 아동 및 그의 법정대리인이 불이익을 입지 않도록 보호 조치를 취하고 있습니다.
나. 회사는 “서비스” 관련, 아동의 개인정보에 대하여 아래의 행위를 하는 경우에는 해당 아동의 법정대리인의 동의를 얻도록 하고 있습니다.
1) 아동의 “서비스” 가입을 위해 개인정보 수집하거나 “서비스” 가입 시 고지한 범위 또는 서비스 이용약관에 명시한 범위를 넘어 이동의 개인정보를 이용하거나 제3자에게 제공하고자 하는 경우
2) 아동의 개인정보를 제공받은 자가 개인정보를 제공받은 목적 외의 용도로 이용하거나 제3자에게 제공하는 경우
다. 이 경우 회사는 법정대리인의 동의를 얻기 위하여 법정대리인의 성명, 연락처 등 필요한 최소한의 정보를 요구할 수 있습니다. 이 경우 개인정보의 수집 · 이용 또는 제공 목적 및 법정대리인의 동의가 필요하다는 취지를 아동이 쉽게 이해 할 수 있는 평이한 표현으로 아동에게 고지합니다.
라. 법정대리인의 동의를 얻기 위하여 수집한 법정대리인의 개인정보를 해당 법정대리인의 동의 여부를 확인하는 목적 외의 용도로 이를 이용하거나 제 3 자에게 제공하지 않습니다.
	광고성 정보 전송
가. “서비스”는 고객의 사전 동의 없이 영리목적의 광고성 정보를 전송하지 않습니다.
나. “서비스”는 신상품이나 이벤트 정보안내 등 고객 지향적인 마케팅을 수행하기 위하여 광고성 정보를 전자매체를 통해 전송하는 경우에는 광고성 정보 전송에 대한 고객의 사전 동의를 득하고 전자매체의 제목란 및 본문란에 아래와 같이 고객이 광고성 정보임을 쉽게 알아 볼 수 있도록 조치합니다. 
다. 전자매체의 제목란 : '(광고)' 또는 '(성인광고)'라는 문구를 제목란의 처음에 빈칸 없이 한글로 표시하고 이어서 전자매체 본문란의 주요 내용을 표시합니다. 단, 제목란 등에 광고임을 표시하기 어려운 전자매체를 통해 영리목적의 광고성 정보를 전송하는 경우에도 전송자의 명칭을 표기하는 등 필요한 조치를 취합니다.
라. “서비스”에서는 고객의 광고성 정보 수신동의시, 수신거부시, 수신동의 철회시 해당 사실을 고객에게 해당 사실 발생일로부터 14일내에 고지합니다. 또한 고객이 광고성 정보 수신동의를 한 날로부터 매 2년 마다 고객의 광고성 정보 수신동의 사실을 고객에게 확인합니다.
	1년간 서비스 미이용자의 개인정보 분리보관 또는 파기
가. “서비스”는 1년간 “서비스”를 이용하지 않은 고객의 개인정보를 분리보관하거나 파기 합니다.
나. “서비스”에서 1년간 “서비스”를 이용하지 않은 것으로 판단하는 기준은 다음과 같습니다.
1) “서비스”에 1년간 로그인을 하지 않은 경우 (단, 로그인을 하지 않아도 연계된 Device에서 자동으로 데이터가 저장된 경우는 예외로 함)
2) “서비스”에서는 상기 분리보관 또는 파기일의 30일전까지 “서비스”에서 수집한 연락처로 개인정보의 분리보관 또는 파기사실을 통지합니다. 단, “서비스”에서 연락처를 수집하지 않는 경우에는 본 개인정보 처리방침의 내용으로 갈음합니다.
	회사 연락처
1. 상 호 : 주식회사 미라벨소프트
2. 대 표 자 : 박기호
3. 주 소 : 서울특별시 서초구 효령로 304 국제전자센터 11층 11054호
4. 대표전화 : 1877-4872
	개인정보 처리방침의 변경
가. 이 개인정보 처리방침은 2020년 6월 01일부터 적용됩니다. 
나. 종전의 방침은 이 방침으로 대체합니다.`}
          </pre>
        </div>
      </div>
    </div>
  );
};
